import React from "react";
import { Box } from "@mui/material";
import ScraperMonitoringDashboard from "../components/ScraperMonitoringDashboard";

function Monitoring() {
  return (
    <Box>
      <ScraperMonitoringDashboard />
    </Box>
  );
}

export default Monitoring;
